import { stateCity, regional, unity } from '../../modules/select';
import { dateRange } from '../../modules/dateRange';
import { userSubscribe } from '../../modules/userSubscribe';
import { _filter } from './_filter';

export const challengesIndex = () => {
  dateRange('up');
  stateCity();
  regional();
  unity();
  userSubscribe();
  _filter();
};
